module.exports = __webpack_public_path__ + "Server-Unknown.AzureSubscription.1dae42d4ff2dcc02167da68176768764.hashedasset.svg";